export function formatDate(value, locale = 'en-KE') {
  if (!value) return '-';
  const date = typeof value === 'string' ? new Date(`${value}T00:00:00`) : value;
  return new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
}

export function formatDateTime(value, locale = 'en-KE') {
  if (!value) return '-';
  const date = typeof value === 'string' ? new Date(value) : value?.toDate ? value.toDate() : value;
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
}
